import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApisAdminOperatorsCompaniesFeatureFlagsUpdateRequestType,
  ApisAdminOperatorsCompaniesFeatureFlagsUpdateResponseType,
} from "~/domains";

type RequestDataType = {
  companyId: string;
  featureKey: string;
  body: ApisAdminOperatorsCompaniesFeatureFlagsUpdateRequestType;
};

const request = ({ companyId, featureKey, body }: RequestDataType) => {
  return new ApiClient()
    .put<ApisAdminOperatorsCompaniesFeatureFlagsUpdateResponseType>(
      `/api/admin_operators/companies/${companyId}/feature_flags/${featureKey}`,
      body,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisAdminOperatorsCompaniesFeatureFlagsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ApisAdminOperatorsCompaniesFeatureFlagsUpdateResponseType> => {
  return useMutation(request, { ...options });
};
